import { State } from "./State";
export class GridRow {
    constructor(id, text) {
        this.id = id;
        this.text = new State(text);
    }
    toJSON() {
        return {
            id: this.id,
            text: this.text.value,
        };
    }
}
